<template functional>
  <span class="season-count">{{ parent.$tc('misc.season', props.amount) }}</span>
</template>

<script>
export default {
  name: 'season-count',
  props: {
    amount: Number
  }
}
</script>

<style lang="scss">
.season-count {
  font-size: 1.2rem;
}
</style>
